export enum Sort {
  AZ = 'a-z',
  ZA = 'z-a',
  CREATED = 'created',
  MODIFIED = 'modified',
  NAME = 'name',
  POPULAR = 'popular',
  TRENDING = 'trending',
  BESTMATCH = 'best-match',
  DATE_ADDED = 'date-added',
  PURCHASED = 'purchased',
  UPLOADED = 'uploaded',
  RECENT = 'recent',
}

export enum UploadAction {
  NEW = 'new',
  UPDATE = 'update',
  REMOVE = 'remove',
}

export interface ExpertContent {
  _id: string;
  entId: string;
  expertId: string;
  contentUrl: string;
  fileType: string;
  fileCategory: string;
  thumbnail: string;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  fileSize: number;
  isExternalFile: boolean;
  isPublic?: boolean;
  urlType?: UrlType;
  path?: string;
  subFolders?: ExpertContent[];
  hasSubFolders?: boolean;
}
export interface SelectedFolderData {
  id: string;
  path: string;
  title?:string;
}

export interface MediaLibraryState {
  loading: boolean;
  modalLoading: boolean;
  filters: {
    keyword: string;
    type: string[];
    sortBy: Sort;
  };
  count: number;
  page: number;
  perPage: number;
  filtersApplied: boolean;
  path: string;
  selectedFiles: string[];
  media: ExpertContent[];
  total: number;
  stroage: RemainingStorage;
  renameMediaFormOpen: boolean;
  openFolderSelect: boolean;
  selectedTargetFolder: SelectedFolderData | null;
  isDownloadMediaEnabled: boolean | null;
  mediaWithSubFolders: ExpertContent[];
  undoButtonDisabled: boolean;
  selectedFilesForUndo: SelectedFolderData[];
  saveAndShareRecording: boolean | null;
  expandedMediaItems: string[];
}

export interface MediaResponse {
  result: ExpertContent[];
  total: number;
}

export interface FetchMediaPayload {
  payload: FetchMediaParams;
  type: string;
}

export interface FetchMediaParams {
  entId: string;
  keyword: string;
  path: string;
  type: string;
  sortBy: string;
  page: number;
  limit: number;
}

export interface Total {
  total: number;
}

export interface RemainingStorage {
  allowedStorage: number;
  mediaStorageSize: number;
  remainingStorage: number;
}

export interface MediaUploadPayload {
  payload: ExpertUploadMediaParam;
  type: string;
}

export enum UrlType {
  PUBLIC_URL = 'public_url',
  YOUTUBE_LINK = 'youtube_link',
}
export interface FetchFolderSelectorMediaPayload {
  payload?: FetchFolderSelectorMediaParams;
  type: string;
}

export interface IUploadMediaModalForm {
  expertId: string;
  entId: string;
  title: string;
  path: string;
  description: string;
  contentUrl: string;
  fileName: string;
  fileType: string;
  fileCategory: string | null;
  isExternalFile: boolean;
  thumbnailGenerated: string;
  urlType?: UrlType;
}
export interface CreateFolderForm {
  name: string;
}

export interface ExpertUploadMediaParam {
  expertId: string | null;
  entId: string;
  contentUrl: string;
  fileName: string;
  fileType: string;
  fileCategory: string | null;
  title: string;
  description: string;
  path: string;
  isExternalFile: boolean;
  thumbnailGenerated: string;
  urlType?: UrlType;
  resolve?: any;
  reject?: any;
}

export interface MoveMediaParam {
  isDragged: boolean;
}
export interface IMoveMedia {
  payload?: MoveMediaParam;
  type: string;
}

export interface FetchFolderSelectorMediaParams {
  parentFolderId?: string;
  folderPath?: string;
}

export interface FetchFolderSelectorMediaResponse {
  result: ExpertContent[];
  parentFolderId: string;
}

export interface IMediaDeletePayload {
  id: string;
  contentUrl: string;
  fileSize: number;
}

export interface IMediaDelete {
  payload: IMediaDeletePayload;
  type: string;
}

export interface IMediaRequestDto {
  page: number;
  limit: number;
  keyword?: string;
  path?: string;
  type?: string[];
  ownership?: string;
}

export interface IMediaUpdate {
  id: string;
  title?: string;
  isPublic?: boolean;
  thumbnailGenerated?: string;
  resolve?: any;
  reject?: any;
  path?: string;
  expertId?: string;
}

export interface IMediaUpdatePayload {
  payload: IMediaUpdate;
  type: string;
}
export interface SaveDownloadVideoTrimmedParams {
  path: string;
  mediaId: string;
  isDownload: boolean;
  isTrimmed: boolean;
  startTime: string;
  endTime: string;
  resolve: any;
  reject: any;
}

export interface SaveDownloadVideoTrimmed {
  payload: SaveDownloadVideoTrimmedParams,
  type: string
}

export enum UploadMode {
  FILE = 'file',
  URL = 'url',
}
